import * as React from 'react';
import ModelContainer from "../../../elements/ModelContentContainer";
import {H2} from "../../../elements/Heading";
import Card from '../../../elements/Card';

class ComingSoon extends React.Component {
  public render() {
    return <ModelContainer>
        <H2>Coming Soon</H2>
        <Card>This section is under development.</Card>
      </ModelContainer>;
  }
}

export default ComingSoon;


// WEBPACK FOOTER //
// ./src/routes/Dashboard/ComingSoon/index.tsx